export default __webpack_public_path__ + "static/media/Mzian Project.52b87a8b.png";